<template>
	<div
		id="offer-detail"
		:class="[!isWeb ? 'mobile-investor-detail' : '', !isWeb && isSafari ? 'safari' : '']"
	>
		<div class="detail-title">
			<div class="detail-title__icon" @click="goToOffers()">
				<SidebarArrow :border="'#0047ff'" />
			</div>
			<h1 class="detail-title__text">{{ offerType }}</h1>
		</div>
		<OfferForm :isWeb="isWeb" />
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import {
	GET_ALL_ORIGINATORS,
	GET_ALL_INDUSTRY,
	GET_ALL_OPERATION,
	GET_ALL_OFFER_STATUS,
	GET_ALL_INDEXER,
	GET_ALL_STRUCTURER,
	GET_ALL_DOC_TYPE,
	GET_ALL_DOC_SUBTYPE,
} from '@/store/modules/offerManagement/actions';
import SidebarArrow from '@/components/shared/Icons/SidebarArrow.vue';
import OfferForm from '@/components/modules/Offer/OfferDetail/OfferForm/OfferForm.vue';

export default {
	name: 'OfferDetail',
	components: { SidebarArrow, OfferForm },
	data: () => ({
		windowWidth: window.innerWidth,
	}),
	created() {
		this.getOriginators({ vm: this });
		this.getOperations({ vm: this });
		this.getIndustries({ vm: this });
		this.getStatus({ vm: this });
		this.getIndexers({ vm: this });
		this.getStructurers({ vm: this });
		this.getDocTypes({ vm: this });
		this.getDocSubtypes({ vm: this });
	},
	mounted() {
		this.$nextTick(() => {
			window.addEventListener('resize', this.onResize);
		});
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.onResize);
	},
	methods: {
		...mapActions('offerManagement', {
			getOriginators: GET_ALL_ORIGINATORS,
			getIndustries: GET_ALL_INDUSTRY,
			getOperations: GET_ALL_OPERATION,
			getStatus: GET_ALL_OFFER_STATUS,
			getIndexers: GET_ALL_INDEXER,
			getStructurers: GET_ALL_STRUCTURER,
			getDocTypes: GET_ALL_DOC_TYPE,
			getDocSubtypes: GET_ALL_DOC_SUBTYPE,
		}),
		onResize() {
			this.windowWidth = window.innerWidth;
		},
		goToOffers() {
			const originator = this.$route.query.originator;

			if (originator) {
				this.$router.push({
					path: '/dashboard/originator/detail',
					query: { id: originator },
				});
			} else {
				this.$router.push({ path: '/dashboard/offers' });
			}
		},
	},
	computed: {
		...mapGetters('offerManagement', [
			'offerOperations',
			'offerStatus',
			'offerIndexers',
			'offerStructurers',
			'offerDocTypes',
			'offerDocSubtypes',
		]),
		isWeb() {
			return this.windowWidth > 992;
		},
		isSafari() {
			return navigator.vendor == 'Apple Computer, Inc.';
		},
		offerType() {
			if (this.$route.query.action) {
				return 'Clonar Oferta';
			}
			return !this.$route.query.id
				? 'Adicionar Oferta'
				: 'Editar Oferta';
		},
	},
};
</script>

<style lang="scss">
@import 'OfferDetail.scss';
</style>
